import { Box } from "@mui/material";
import DbRuler from "./DbRuler";
import FrequencyRuler from "./FrequencyRuler";
import ChannelSelector from "./ChannelSelector";

const WaveformDisplay = ({
  wavesurferReady,
  waveSurferHeight,
  mainRef,
  sampleRate,
  fftFrequencies,
  setFrequencyRange,
  children,
  clip,
  preferencesSave,
  mode,
}) => {
  return (
    <Box
      ref={mainRef}
      sx={{
        flex: "1 1 auto",
        height: waveSurferHeight + 30,
        position: "relative",
        overflowX: "hidden",
        overflowY: "hidden",
        paddingRight: "50px",
        paddingLeft: "50px",
      }}
    >
      {wavesurferReady && (
        <>
          <DbRuler
            font="Roboto"
            fontSize="8"
            maxDb="0"
            height={waveSurferHeight}
          />
        </>
      )}
      {children}
      {wavesurferReady && (
        <>
          <FrequencyRuler
            font="Roboto"
            fontSize="8"
            max={sampleRate / 2}
            frequencyMax={fftFrequencies.max}
            frequencyMin={fftFrequencies.min}
            setFrequencyRange={setFrequencyRange}
            height={waveSurferHeight}
          />
        </>
      )}
      {wavesurferReady && (
        <>
          {clip?.numberOfChannels > 1 && mode !== "sng" && (
            <ChannelSelector clip={clip} preferencesSave={preferencesSave} />
          )}
        </>
      )}
    </Box>
  );
};

WaveformDisplay.displayName = "WaveformDisplay";

export default WaveformDisplay;
